import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=537ba798&scoped=true&"
import script from "./Resume.vue?vue&type=script&lang=ts&"
export * from "./Resume.vue?vue&type=script&lang=ts&"
import style0 from "./Resume.vue?vue&type=style&index=0&id=537ba798&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537ba798",
  null
  
)

export default component.exports